export default __webpack_public_path__ + "static/media/webusingreactjs3.9b223277.jpg";